import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
} from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Subscription } from 'rxjs'
import { environment } from 'src/environments/environment'

import { AdobeLaunchService } from '../../server/adobe-launch/adobe-launch.service'
import { ProfileResponse } from '../models/profile-response.model'
import { AdobeAnalyticsService } from '../services/adobe-analytics/adobe-analytics.service'
import { AEMChunk } from '../services/AEM/aem-chunk.model'
import { CentralContentService } from '../services/content/central-content.service'
import { MainService } from '../services/main.service'

const NEGATIVE_ONE = -1
const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/

@Component({
  selector: 'profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit, OnDestroy {
  tickerOrFundId: string
  barChartSection: string
  routeSubscription: Subscription
  profileSubscription: Subscription
  isValidFund = true
  isInvalidFund = false
  isHiddenFundId = false
  innerWidth: number
  is529Fund: boolean
  adobeLaunchPage: any
  data: ProfileResponse
  isExternalFund: boolean
  isInternalFund: boolean
  nonVanguardFundsViewableFlag: boolean
  hiddenFunds: AEMChunk
  aemContentSub: Subscription

  // eslint-disable-next-line max-params
  constructor(
    private readonly route: ActivatedRoute,
    private readonly mainService: MainService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly centralContentService: CentralContentService,
    public adobeLaunchService: AdobeLaunchService,
  ) {}
  @HostListener('window:resize', ['$event']) onResize() {
    this.detectScreenSize()
  }
  ngAfterViewInit(): void {
    this.setNavBar()
  }

  detectScreenSize() {
    this.innerWidth = window.innerWidth
  }

  // eslint-disable-next-line max-statements
  ngOnInit() {
    this.data = this.route.snapshot?.data?.fundDetails as ProfileResponse
    const tickerOrFundId = this.route.snapshot.paramMap.get('tickerOrFundId')
    this.tickerOrFundId = tickerOrFundId
    this.isInvalidFund = specialChars.test(this.tickerOrFundId)
    this.nonVanguardFundsViewableFlag = environment.nonVanguardFundsViewableFlag

    if (!this.isInvalidFund && this.data?.fundProfile) {
      this.mainService.getFundData(this.tickerOrFundId)
      this.loadHiddenFunds()
      this.isExternalFund = this.data.fundProfile?.isExternalFund
      this.isInternalFund = this.data.fundProfile?.isInternalFund
      this.is529Fund = this.data.fundProfile?.is529
      this.adobeLaunchPage = {
        pageTemplate: this.tickerOrFundId,
      }
      this.adobeLaunchService.initializePage(
        this.adobeLaunchPage,
        environment.adobeLaunchEnv,
      )
      this.detectScreenSize()
    }
  }

  loadHiddenFunds() {
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
  }

  parseAEMContent(content) {
    this.hiddenFunds = this.centralContentService.getContentByBody(
      'configuration_hidden_fund_ids',
      content,
    )
    this.validateFunds()
  }

  validateFunds() {
    const hiddenFundsArray = this.hiddenFunds.contentValue?.split(',')
    this.isValidFund =
      hiddenFundsArray.indexOf(this.data.fundProfile?.fundId) === NEGATIVE_ONE
    this.isHiddenFundId =
      hiddenFundsArray.indexOf(this.data.fundProfile?.fundId) > NEGATIVE_ONE
  }

  setNavBar() {
    this.routeSubscription = this.route.fragment.subscribe((fragment) => {
      if (fragment) {
        this.barChartSection = fragment
        this.changeDetector.detectChanges()
      }
    })
  }
  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe()
    this.profileSubscription.unsubscribe()
  }
}
